import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NiceSelectModule } from "ng-nice-select";
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';

import { SettlementsRoutingModule } from '@teem/settlements-module/settlements-routing.module';
import { SettlementsHeaderComponent } from '@teem/settlements-module/components/settlements-header/settlements-header.component';
import { SettlementsTabHeaderComponent } from '@teem/settlements-module/components/settlements-tab-header/settlements-tab-header.component';
import { SettlementsComponent } from '@teem/settlements-module/settlements.component';

@NgModule({
  declarations: [
    SettlementsComponent,
    SettlementsHeaderComponent,
    SettlementsTabHeaderComponent
  ],
  entryComponents: [
    
  ],
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SettlementsRoutingModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
  ]
})
export class SettlementsModule { }
